import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Fragment } from 'react';
import { Widget } from '@typeform/embed-react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import grayLogo from '../../../assets/images/Logo_Gray.svg';
import './TypeformModal.scss';
var TYPEFORM_HEIGHT = '400px';
var TYPEFORM_WIDTH = '600px';
var confirmationBody = /*#__PURE__*/React.createElement("div", {
  className: "confirmation-body"
}, /*#__PURE__*/React.createElement("img", {
  src: grayLogo,
  alt: "Clora Logo",
  height: "40",
  width: "93"
}), /*#__PURE__*/React.createElement("h1", {
  className: "confirmation-header"
}, "Thanks for sharing your feedback!"), /*#__PURE__*/React.createElement("div", {
  className: "confirmation-subtitle"
}, "Your feedback is important to us and will help us improve your experience."));
var TypeformModal = /*#__PURE__*/function (_React$Component) {
  function TypeformModal(props) {
    var _this;
    _classCallCheck(this, TypeformModal);
    _this = _callSuper(this, TypeformModal, [props]);
    _this.state = {
      showConfirmation: false,
      showModal: true
    };
    return _this;
  }
  _inherits(TypeformModal, _React$Component);
  return _createClass(TypeformModal, [{
    key: "typeformBody",
    value: function typeformBody() {
      var _this2 = this;
      var _this$props = this.props,
        headerCopy = _this$props.headerCopy,
        actionCopy = _this$props.actionCopy,
        promptCopy = _this$props.promptCopy,
        typeformId = _this$props.typeformId,
        typeformParams = _this$props.typeformParams;
      return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: "typeform-text"
      }, /*#__PURE__*/React.createElement("h1", {
        className: "typeform-header-text"
      }, headerCopy), /*#__PURE__*/React.createElement("div", {
        className: "typeform-subtitle-text body-text-1"
      }, actionCopy), /*#__PURE__*/React.createElement("div", {
        className: "typeform-subtitle-text body-text-1"
      }, promptCopy), /*#__PURE__*/React.createElement("hr", {
        className: "mt-0 mb-0"
      })), typeformId && /*#__PURE__*/React.createElement(Widget, {
        id: typeformId,
        style: {
          height: TYPEFORM_HEIGHT,
          width: TYPEFORM_WIDTH
        },
        hidden: typeformParams,
        onSubmit: function onSubmit() {
          return _this2.setState({
            showConfirmation: true
          });
        }
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var _this$state = this.state,
        showConfirmation = _this$state.showConfirmation,
        showModal = _this$state.showModal;
      return /*#__PURE__*/React.createElement(Modal, {
        show: showModal,
        onHide: function onHide() {
          return _this3.setState({
            showModal: false
          });
        },
        dialogClassName: "typeform-modal"
      }, /*#__PURE__*/React.createElement(Modal.Header, {
        closeButton: true
      }), /*#__PURE__*/React.createElement(Modal.Body, {
        className: "typeform-modal-body style-guide".concat(showConfirmation ? ' confirmation' : '')
      }, showConfirmation ? confirmationBody : this.typeformBody()));
    }
  }]);
}(React.Component);
TypeformModal.propTypes = {
  typeformId: PropTypes.string.isRequired,
  typeformParams: PropTypes.shape({}),
  headerCopy: PropTypes.string.isRequired,
  actionCopy: PropTypes.string.isRequired,
  promptCopy: PropTypes.string.isRequired
};
TypeformModal.defaultProps = {
  typeformParams: {}
};
export default TypeformModal;